import axios from 'axios'
import { Commands } from '@/apis/commands'

const Atmos = {

    async getSubscriptions() {
        var subs = (await axios.get('/SoftPro.Atmos/Subscriptions')).data;
        subs.unshift({
            id: null,
            name: "(All)",
            desc: null,
            serialNumber: null,
            createdOn: null,
            createdBy: null,
            lastUpdatedOn: null,
            lastUpdatedBy: null
        });
        return subs;
    },

    async getSubscription(id) {
        return (await axios.get('/SoftPro.Atmos/Subscriptions/' + id)).data;
    },

    async removeSubscription(id) {
        var ticket = (await axios.delete('/SoftPro.Atmos/Subscriptions/' + id)).data;
        await Commands.resolveCommand(ticket);
    },

    async addSubscription(name, sn, desc) {
        name = name.trim();
        var ticket = (await axios.post('/SoftPro.Atmos/Subscriptions', {
            name: name,
            sn: sn,
            desc: desc
        })).data;
        var result = await Commands.resolveCommand(ticket);
        return await this.getSubscription(result.id);        
    },

    async updateSubscription(id, name, sn, desc) {
        name = name.trim();        
        var ticket = (await axios.put('/SoftPro.Atmos/Subscriptions/' + id, {
            id: id,
            name: name,
            sn: sn,
            desc: desc
        })).data;
        var result = await Commands.resolveCommand(ticket);
        return await this.getSubscription(result.id);
    },

    async getApplicationTypes() {
        return (await axios.get('/SoftPro.Atmos/ApplicationTypes')).data;
    },

    async getApplicationTypeManifest(name, version) {
        name = name.trim();
        version = version.trim();
        return (await axios.get(`/SoftPro.Atmos/ApplicationTypes/${name}/manifest?version=${version}`)).data;
    },

    async getApplicationInstances(sub) {
        var apps = (await axios.get('/SoftPro.Atmos/ApplicationInstances')).data;
        return apps.filter(i => sub == null || i.subscription == sub);    
    },

    async getApplicationInstance(name) {
        name = name.trim();
        return (await axios.get('/SoftPro.Atmos/ApplicationInstances/' + name)).data;
    },

    async addApplicationInstance(sub, type, version, name, expiresOn, parameters) {
        name = name.trim();        
        var ticket = (await axios.post('SoftPro.Atmos/ApplicationInstances', {
            subscription: sub,
            name: name,
            type: type,
            version: version,
            expiresOn: expiresOn,
            parameters: parameters
        })).data;

        var result = await Commands.resolveCommand(ticket);
        return await this.getApplicationInstance(result.name);
    },

    async upgradeApplicationInstance(name, version, parameters) {
        name = name.trim();        
        var ticket = (await axios.put(`SoftPro.Atmos/ApplicationInstances/${name}?version=${version}`, 
            parameters
        )).data;

        var result = await Commands.resolveCommand(ticket);
        return await this.getApplicationInstance(result.name);
    },

    async removeApplicationInstance(name) {
        name = name.trim();
        var ticket = (await axios.delete('SoftPro.Atmos/ApplicationInstances/' + name)).data;
        await Commands.resolveCommand(ticket);
    },

    async undeployApplicationInstance(name) {
        name = name.trim();
        var ticket = (await axios.put(`SoftPro.Atmos/v2/ApplicationInstances/${name}?action=undeploy`, {})).data;
        await Commands.resolveCommand(ticket);
    },

    async deployApplicationInstance(name) {
        name = name.trim();
        var ticket = (await axios.put(`SoftPro.Atmos/v2/ApplicationInstances/${name}?action=deploy`, {})).data;
        await Commands.resolveCommand(ticket);
    },
}

export { Atmos };
